export enum FeFilterPresetsKind {
  AdminSitePerformanceMonitoring = 'adminSitePerformanceMonitoring',
  AdminSectorPerformanceMonitoring = 'adminSectorPerformanceMonitoring',
}
